import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface QRCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  qrCodeUrl: string;
  title: string;
}

const QRCodeModal: React.FC<QRCodeModalProps> = ({ isOpen, onClose, qrCodeUrl, title }) => {
  const { t } = useTranslation();
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div 
        className="fixed inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative bg-white rounded-lg p-6 max-w-sm w-full mx-4 z-50">
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-2 top-2"
          onClick={onClose}
        >
          <X className="h-4 w-4" />
        </Button>
        <div className="text-center">
          <h3 className="text-lg font-medium mb-4">{title}</h3>
          <div className="flex justify-center mb-4">
            <img 
              src={qrCodeUrl} 
              alt={`${title}二维码`} 
              className="max-w-[200px] max-h-[200px] w-auto h-auto object-contain"
            />
          </div>
          <p className="text-sm text-gray-500">{t('common.scanQR')}</p>
        </div>
      </div>
    </div>
  );
};

export default QRCodeModal; 